<template>
  <Container class="container-sm-none">
    <Progressbar :step="childrenWithIndexes.length > 0 && adultsWithIndexes.length === 0 ? 6 : 9" :step-count="model.stepCount">
      Select Policyholder
    </Progressbar>
    <Card class="card-shadow">
      <div class="width-lg">
        <div class="pl-10 pl-md-0 pr-10 pr-md-0">
          <Collapse
            v-for="(person, index) in model.insuredPersons.array_hd7ov6$_0"
            :key="index + 1"
            :index="index"
            @change="setOpened"
            :model="model"
            :person-count="model.insuredPersons.array_hd7ov6$_0.length + 1"
          >
            <template v-slot:title>
              <p v-if="person.name && person.surname">
                {{`${person.name} ${person.surname}`}}
              </p>
              <p v-else>
                Policyholder {{`${index + 1}`}}
              </p>
            </template>
            <InsuranceCard
              class="mb-10"
              title='Adult'
              :icon="require('@/assets/svg/adult-person-icon.svg')"
              :enumValue="InsuranceType.ADULT"
              :value="person.insuranceType"
              :person="person"
            >
              <IconRight class="ic-arrow-icon" />
            </InsuranceCard>

            <InsuranceCard
              class="mb-10"
              title='Child Under 18 Years'
              :icon="require('@/assets/svg/horse-icon.svg')"
              :enumValue="InsuranceType.CHILD"
              :value="person.insuranceType"
              :person="person"
            >
              <IconRight class="ic-arrow-icon" />
            </InsuranceCard>
          </Collapse>
          <Collapse
            :index="model.insuredPersons.array_hd7ov6$_0.length"
            :opened-index="openedIndex"
            :opened="true"
            :new-person="true"
            :model="model"
            :person-count="model.insuredPersons.array_hd7ov6$_0.length + 1"
            disable-remove
          >
            <template v-slot:title>
              <p>
                Policyholder {{`${model.insuredPersons.array_hd7ov6$_0.length + 1}`}}
              </p>
            </template>
            <h3 class="heading-3 weight-medium pb-10 pb-md-16 text-left text-md-center">
              Who do you want to insure?
            </h3>

            <InsuranceCard
              class="mb-10"
              title='Adult'
              :icon="require('@/assets/svg/adult-person-icon.svg')"
              :enumValue="InsuranceType.ADULT"
              @input="addPerson"
            >
              <IconRight class="ic-arrow-icon" />
            </InsuranceCard>

            <InsuranceCard
              class="mb-10"
              title='Child Under 18 Years'
              :icon="require('@/assets/svg/horse-icon.svg')"
              :enumValue="InsuranceType.CHILD"
              @input="addPerson"
            >
              <IconRight class="ic-arrow-icon" />
            </InsuranceCard>
          </Collapse>

          <ButtonGroup class="pt-10">
            <Button
              class="btn-outline-tertiary w-full"
              @click="redirectBack"
            >
              Back
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Card>
  </Container>
</template>
<script>
import InsuranceCard from '@/components/InsuranceCard/InsuranceCard.vue';
import IconRight from '@/components/Icons/IconRight.vue';
import Card from '@/components/Card/Card.vue';
import Progressbar from '@/components/Progressbar/Progressbar.vue';
import ButtonGroup from '@/components/ButtonGroup/ButtonGroup.vue';
import Container from '@/components/Container/Container.vue';
import Button from '@/components/Button/Button.vue';
import enums from '@/mixins/enums';
import persons from '@/mixins/persons';
import routes from '@/mixins/routes';
import Collapse from '@/components/Collapse/Collapse.vue';
import GA from '@/mixins/GA';

export default {
  name: 'NextInsuranceTypePage',
  components: {
    Collapse,
    Button,
    Container,
    ButtonGroup,
    Progressbar,
    Card,
    IconRight,
    InsuranceCard,
  },
  data() {
    return {
      openedIndex: -1,
    };
  },
  mixins: [enums, persons, routes, GA],
  props: {
    model: {
      type: Object,
      required: true,
    },
    errors: {
      type: Array,
      required: true,
    },
  },
  computed: {
    InsuranceType() { return this.enums.InsuranceTypeEnum; },
  },
  methods: {
    addPerson(type) {
      if (this.insuredPersons.length < 5) {
        const { InsuredPerson_init } = this.$kotlin.model;
        const newPerson = InsuredPerson_init();
        this.setPersonCountries(newPerson);
        this.insuredPersons.push(newPerson);

        this.model.stepCount = 13;

        if (type === this.InsuranceType.CHILD) {
          newPerson.isAdult = false;
          newPerson.insuranceType = this.InsuranceType.CHILD;
        } else {
          newPerson.isAdult = true;
          newPerson.insuranceType = this.InsuranceType.ADULT;
        }

        // this.$gtm.dataLayer().push({
        //   event: 'eventPush',
        //   eventCategory: 'zp - pridať ďalšiu osobu',
        //   eventAction: 'pridať',
        //   eventLabel: undefined,
        //   eventValue: undefined,
        //   eventNonInteraction: false,
        // });

        /*
        * EID type cannot be selected for family (2 and more persons)
        * */
        const { DeliveryTypeEnum } = this.enums;
        if (this.model.delivery.deliveryType === DeliveryTypeEnum.EID) {
          this.model.delivery.deliveryType = null;
        }

        this.model.insuranceType = this.InsuranceType.FAMILY;
        // nastavim index na zaciatok visitedSteps
        this.model.currentPersonStepIndex = 0;
        // inkrementujem na dalsiu osobu
        this.model.currentPersonIndex = this.model.insuredPersons.array_hd7ov6$_0.length - 1;
        // pridavam rovno tejto novej osoby step 3 lebo tam kazda nova osoba zacina
        this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.push(3);
        this.model.insuredPersons.array_hd7ov6$_0.forEach((person) => {
          person.visitedSteps.array_hd7ov6$_0 = person.visitedSteps.array_hd7ov6$_0.filter((step) => step < 16);
        });
        this.$router.goToStep(3);
      }
    },
    redirectBack() {
      const indexOfRemovedStep = this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.indexOf(9);
      this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.splice(indexOfRemovedStep, 1);
      this.$router.goToStep(this.getNearestPreviousAvailableStep());
    },
    setOpened(index) {
      this.openedIndex = index;
    },
  },
  created() {
    this.model.step = 9;
    if (this.model.lastStep < 9) this.model.lastStep = 9;
  },
  mounted() {
    this.funnelStep('Výber poistenca');
  },
};
</script>
